import { useMutation } from "@tanstack/react-query";

import type { BookEventSlotPayload } from "../../api/book-event/book-event.type";

import { bookEventSlot } from "../../api/book-event/book-event";

export function useBookEventSlot() {
  return useMutation({
    mutationFn: (payload: BookEventSlotPayload) => bookEventSlot(payload),
    onError: (error) => {
      return error;
    },
  });
}
